<template>
  <BaseModal :title="$t('Upload another file')">
    <Autocomplete v-model="currency" :label-text="$t('Project currency')" :items="currencyItems" />
    <FileAttachment
      :default-label="false"
      :files="files"
      @file-input="handleFileInput"
      @file-delete="handleFileDelete"
    >
      <template #label>
        <!--    TODO: ссылки для скачивания файлов    -->
        <div class="text-sm grey-500">
          <span>
            {{ $t('You can') }} <span class="link">{{ $t('use our Excel template') }}</span>
            {{ $t('and upload it here.') }} <br />
            {{ $t('Or prepare your existing .xlsx or .xls bill of quantity. ') }}
            <span class="link">{{ $t("Here's the short guide") }}</span>
            {{ $t('on how to do that.') }}
          </span>
        </div>
      </template>
    </FileAttachment>
    <template #footer>
      <div v-if="files.length" class="spacex-12 flex-end width-100">
        <SuccessAlert v-if="success" class="flex-1" />
        <ErrorAlert v-else-if="error" :error="error" class="flex-1" />
        <Button color="neutral" @click.native="closeModal">
          {{ $t('Cancel') }}
        </Button>
        <Button :loading="isLoading" @click.native="submit">
          {{ $t('Refresh estimate') }}
        </Button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import FileAttachment from '@/components/projects/FileAttachment';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/formatting/parse-error';
  import Button from '@/components/ui/Button';
  import SuccessAlert from '@/components/common/SuccessAlert';
  import ErrorAlert from '@/components/common/ErrorAlert';
  import Autocomplete from '@/components/ui/Autocomplete';
  import { mapActions, mapGetters } from 'vuex';
  import request from '@/utils/api/request';

  export default {
    name: 'ImportFileModal',
    components: {
      Button,
      FileAttachment,
      BaseModal,
      SuccessAlert,
      ErrorAlert,
      Autocomplete,
    },
    props: {
      /** {
       * id: number // project id
       * update: () => void
       } */
      context: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        files: [],
        isLoading: false,
        error: null,
        success: false,
        currency: null,
      };
    },
    computed: {
      ...mapGetters({
        currencyItems: 'global/currencySelectItems',
      }),
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
      }),
      async submit() {
        this.error = null;
        this.success = false;

        if (!this.files?.length) {
          this.error = 'No file attached';
          return;
        }

        this.isLoading = true;

        const data = new FormData();
        data.append('file', this.files[0]);

        try {
          await request.post(`/projects/${this.context.id}/currency/`, { currency: this.currency });
          await factory('projects').patchInPath(this.context.id, data);
          this.isLoading = false;
          this.success = true;
          this.context.update?.();
          this.$emit('close');
        } catch (e) {
          this.isLoading = false;
          console.error(parseError(e) || e); // eslint-disable-line
          this.error = parseError(e) || e;
        }
      },
      handleFileInput(files) {
        this.error = null;
        this.files = files;
      },
      handleFileDelete() {
        this.files = [];
      },
    },
    created() {
      if (this.currencyItems?.[0]?.value) {
        this.currency = this.currencyItems[0].value;
      }
    },
  };
</script>
